import { z } from "zod";

export const videoTokenResponseSchema = z.object({
	auth_token: z.string(),
	rtk_meeting_id: z.string(),
});

export type VideoTokenResponse = z.infer<typeof videoTokenResponseSchema>;
